module.exports = __webpack_public_path__ + "static/media/styles.54cd10b6.less";